(function () {
    var header = document.querySelector('.header');
    if (!header) return;
    var onScroll = function () {
        if (window.scrollY > 10) header.classList.add('header--scrolled');
        else header.classList.remove('header--scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
})();
